import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Card } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIntl } from '@grandvisionhq/state';
import { StringUtils } from '@grandvisionhq/utils';

const Appointment = ({ appointment  })=>{
    const { dateTime  } = useIntl();
    const { id , startTime , store  } = appointment;
    const appointmentDetailLinkProps = useLink({
        route: 'me.appointments.detail',
        params: {
            appointmentId: id
        }
    });
    var ref, _streetNumber;
    return /*#__PURE__*/ React.createElement(Card, swcHelpers.extends({}, appointmentDetailLinkProps), /*#__PURE__*/ React.createElement(Card.Content, {
        childrenWrapperClassName: "profile-appointment-card__wrapper"
    }, /*#__PURE__*/ React.createElement(Card.Section, {
        flex: true,
        className: "profile-appointment-card__section"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Card.Icon, {
        name: "calendar",
        height: 32,
        width: 32
    })), /*#__PURE__*/ React.createElement(Card.Section, {
        className: "profile-appointment-card__body"
    }, /*#__PURE__*/ React.createElement(Card.Heading, null, dateTime.formatShortDate(startTime), " ", dateTime.formatTime(startTime)), (store === null || store === void 0 ? void 0 : store.streetName) && /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "caption",
        color: "text-secondary",
        className: "profile-appointment-card__address"
    }, `${StringUtils.upFirst((ref = store === null || store === void 0 ? void 0 : store.streetName) !== null && ref !== void 0 ? ref : '')} ${(_streetNumber = store.streetNumber) !== null && _streetNumber !== void 0 ? _streetNumber : ''}, ${store === null || store === void 0 ? void 0 : store.town}`)))));
};
Appointment.displayName = 'Appointment';

export { Appointment };
//# sourceMappingURL=Appointment.js.map
